import { render, staticRenderFns } from "./explore.vue?vue&type=template&id=dacccf92&"
import script from "./explore.vue?vue&type=script&lang=js&"
export * from "./explore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterMobile: require('/opt/buildhome/repo/components/footer-mobile/index.vue').default,NotificationSubscriber: require('/opt/buildhome/repo/components/notification/NotificationSubscriber.vue').default})
